
// ----------------------------------------------------------------
// Accounts routes
// ----------------------------------------------------------------

const accountRoutes = {

  // Allowance routes
  allowance_type: {
    get: "allowance_type",
    post:"allowance_type",
    put:"allowance_type/",
    delete:"allowance_type/"
  },

  // contributin routes

  contributin_type:{
    Post:"contribution_type",
    put:"contribution_type/",
    delete:"contribution_type/",
  },

  levies_type:{
    post:"levies_type",
    put:"levies_type/",
    delete:"levies_type/"
  }

}

// Export Accounts Routs
export default accountRoutes
